import { render } from "./ZoneWizardLaunchZone.vue?vue&type=template&id=61038dec&scoped=true"
import script from "./ZoneWizardLaunchZone.vue?vue&type=script&lang=js"
export * from "./ZoneWizardLaunchZone.vue?vue&type=script&lang=js"

import "./ZoneWizardLaunchZone.vue?vue&type=style&index=0&id=61038dec&scoped=true&lang=less"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61038dec"]])

export default __exports__